import { InjectionToken, Provider } from '@angular/core';
import { RemoteIntegrationShellMethods } from '../models/remote-integration-shell-methods';

/**
 * Injection token for shell methods shared with every mounted integration.
 * Shared methods are merged with the methods configured on each integration config.
 */
export const RemoteIntegrationSharedMethods = new InjectionToken<RemoteIntegrationShellMethods>('RemoteIntegrationSharedMethods', {
  providedIn: 'root',
  factory: (): RemoteIntegrationShellMethods => ({}),
});

/** Provides shared shell methods for all integrations using a factory function. */
export const provideRemoteIntegrationSharedMethods = (factory: () => RemoteIntegrationShellMethods): Provider => ({
  provide: RemoteIntegrationSharedMethods,
  useFactory: factory,
});
